import React from 'react';
import { createContext } from 'react';

export interface ILayoutHeaderProviderProps {
  children: React.ReactNode;
}

const LayoutHeaderContext = createContext<{
  height: number;
  useResizeEffect: (headerRef: React.RefObject<HTMLElement | null>) => void;
}>({
  height: 0,
  useResizeEffect: () => {},
});

function LayoutHeaderProvider({ children }: ILayoutHeaderProviderProps) {
  const [height, setHeight] = React.useState<number>(0);

  const useResizeEffect = (headerRef: React.RefObject<HTMLElement | null>) =>
    React.useEffect(() => {
      headerRef.current?.clientHeight &&
        setHeight(headerRef.current.clientHeight);

      window.addEventListener('resize', () => {
        headerRef.current?.clientHeight &&
          setHeight(headerRef.current.clientHeight);
      });

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  return (
    <LayoutHeaderContext.Provider
      value={{
        height,
        useResizeEffect,
      }}
    >
      {children}
    </LayoutHeaderContext.Provider>
  );
}

export { LayoutHeaderContext, LayoutHeaderProvider };
